import React, { useEffect, useState } from 'react';
import { Publication } from '../interfaces/prof/PublicationInterface';
import './publication.css';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';


const InternationalJournal: React.FC = () => {
    const [data, setData] = useState<Publication[]>([]);
    const [groupedData, setGroupedData] = useState<{[key: string]: Publication[]}>({});
    const API_BASE_URL = 'http://220.69.209.170:3333';

    const fetchAPI = async (endpoint: string) => {
        try {
            const response = await fetch(`${API_BASE_URL}${endpoint}`);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchAPI('/papers/getInternationalJournal');
    }, []);

    useEffect(() => {
        const grouped = data.reduce((acc, paper) => {
            const year = paper.year.substring(0, 4); // 연도 앞 4자리 추출
            if (!acc[year]) {
                acc[year] = [];
            }
            acc[year].push(paper);
            return acc;
        }, {} as {[key: string]: Publication[]});

        setGroupedData(grouped);
    }, [data]);

    return (        
        <div>
            {Object.keys(groupedData).sort().reverse().map((year) => (
                <div key={year} className="yearSection">
                    <h3 className="yearTitle"><CalendarTodayIcon />{year}</h3>
                    <ul className="publicationList">                    
                        {groupedData[year].map((paper, index) => (                            
                            <li key={index} className="publicationItem">                               
                                ■ <b> "{paper.title}" </b><br></br>
                                &nbsp;&nbsp;&nbsp;&nbsp;{paper.authors}<br></br>
                                &nbsp;&nbsp;&nbsp;&nbsp;{paper.journal}, {paper.year} [<a href={paper.link} target="_blank" rel="noopener noreferrer">link</a>]
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}

export default InternationalJournal;
